module.exports = __webpack_public_path__ + "img/isomatch_grip.ce1ebf2b.jpg";